const Account = () => {
    return (
        <div>
            <h1>Compte</h1>
        </div>
    );
};

export default Account;
